<template>
  <dialog-template 
    :headerTitle="'删除商品'" 
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :width="'400px'">
    <p class="question text-popper" v-textPopper v-if="goodsNum > 1">确定要删除当前选中的<span>{{ goodsNum }}</span>种商品吗？</p>
    <p class="question text-popper" v-textPopper v-else>确定删除商品 <span>{{ goodsName }}</span> 吗？</p>
    <p class="tips">删除后商品将不可再次出售，会从后台移除</p>
    <div class="btn-wrapper" slot="footer">
        <el-button :loading="isOnSubmit" size="medium" type="danger" @click="confirm">确认删除</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
    </div>
  </dialog-template>
</template>

<script lang="ts">
import { createComponent, ref, computed } from '@vue/composition-api'
import { $fetch } from '@/api/index'
import { openMessage } from '@/utils/system.tsx'
import { setObjectItemToFixed } from '@/utils/index'

export default createComponent({
    setup() {
        const dialogVisible = ref(false)
        const goodsNum = ref<number | undefined>(0)
        const goodsIds = ref<number[] | undefined>()
        const groupId = ref<number | undefined>()
        const secondaryGroupId = ref<number | undefined>()
        const isOnSubmit = ref(false)
        const goodsName = ref<string | undefined>('')

        let confirmCallback = () => {}
        function open(options: {
            goods_num?: number,
            goods_ids?: number[],
            group_id?: number,
            goods_name?: string,
            secondary_group_id?: number,
            callback: () => void
        }) {
            goodsIds.value = options.goods_ids
            groupId.value = options.group_id
            secondaryGroupId.value = options.secondary_group_id
            goodsNum.value = options.goods_num
            goodsName.value = options.goods_name
            confirmCallback = options.callback
            dialogVisible.value = true
        }

        function confirm() {
            if (isOnSubmit.value) {
                return
            }
            isOnSubmit.value = true
            $fetch.post({
                url: '/goods/editgoodsstatus',
                params: {
                    goods_ids: goodsIds.value,
                    group_id: groupId.value,
                    secondary_group_id: secondaryGroupId.value,
                    status: -1
                }
            }).then(data => {
                openMessage('success', '删除成功')
                confirmCallback()
                dialogVisible.value = false
            }).catch(e => {
                openMessage('error', e.message)
            }).finally(() => {
                isOnSubmit.value = false
            })
        }

        return {
            goodsNum,
            goodsIds,
            goodsName,
            dialogVisible,
            open,
            confirm,
            isOnSubmit
        }
    }
})
</script>

<style lang="scss" scoped>
p {
    text-align: center;
}

.question {
    height: 20px;
    line-height: 20px;
    color: #333;
    font-size: 14px;
    font-weight: 500;

    span {
        font-weight: bold;
    }
}

.tips {
    height: 16px;
    line-height: 16px;
    margin-top: 8px;
    font-size: 12px;
    color: #666;
}

.btn-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .btn {
        width: 100px;
        height: 36px;
        line-height: 36px;
        padding: 0;
        text-align: center;
        border-radius: 4px;
        font-size: 14px;
        box-sizing: border-box;
        outline: none;

        &.del {
            
            background: #E51C23;
            color: #fff;
            border: 1px solid #E51C23;
        }

        &.cancel {
            margin-left: 10px;
            background: #fff;
            color: #666;
            border: 1px solid #ddd;
        }
    }
}
</style>
